import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { ADDRESS_BOOK_STORE } from '@constants/store'
import { GENERAL_STORE } from '../store'

export default {
  props: {
    dot: Object,
  },

  watch: {
    availableDates: {
      handler(availableDates) {
        const isEmpty = availableDates.length === 0

        const isDateFounded = this.date
          ? availableDates.find(date => date.value === this.date)
          : false

        if (!isEmpty && !isDateFounded) {
          this.updateDot({
            dot: this.dot,
            data: {
              key: 'date',
              value: availableDates[0].value,
            },
          })
          this.calculatePrice()
        }
      },
      immediate: true,
    },

    async date() {
      if (this.base.isAdmin) return

      const minTimeFrom = this.form.allTimes.find(time => time.value >= this.currentDate.time).value

      const setMinTime = () => {
        this.updateDot({
          dot: this.dot,
          data: {
            key: 'timeFrom',
            value: minTimeFrom,
          },
        })
      }

      if (this.isCurrentDate) {
        setMinTime()
      } else {
        this.updateDot({
          dot: this.dot,
          data: {
            key: 'timeFrom',
            value: '00:00',
          },
        })
      }

      this.updateDot({
        dot: this.dot,
        data: {
          key: 'timeTo',
          value: '23:59',
        },
      })

      await this.setAddressBookItemTime() // Попытаться установить время из адресной книги

      if (!this.thisDotIndex && this.isCurrentDate && this.dot.timeFrom < minTimeFrom) setMinTime()

      this.calculatePrice()
    },
  },

  computed: {
    ...mapState(GENERAL_STORE, ['form', 'base', 'currentDate', 'order', 'monthStrings']),
    ...mapGetters(GENERAL_STORE, ['getDotIndex', 'selectedCity']),

    initialDate() {
      // Какая-то лютая залупа у вью,..
      // Если в компьютеде не учавствует dotIndex, то при одинаковых initialDate он классно оптимизурет и обновляет компьютед только для последней точки
      return this.thisDotIndex ? this.dot.initialDate : this.dot.initialDate
    },

    date: {
      get() {
        return this.dot.date
      },
      async set(value) {
        this.updateDot({ dot: this.dot, data: { key: 'date', value } })

        if (!this.thisDotIndex) {
          this.order.dots.forEach((dot, dotID) => {
            if (dotID !== 0 && dot.date <= value) {
              this.updateDot({
                dot: this.order.dots[dotID],
                data: {
                  key: 'date',
                  value,
                },
              })
            }
          })
        }

        // if (!this.thisDotIndex) {
        //   await this.setAddressBookItemTime() // Попытаться установить время из адресной книги
        // }
        // await this.calculatePrice()
      },
    },

    thisDotIndex() {
      return this.getDotIndex(this.dot)
    },

    availableDates() {
      // Даем доступ админам ко всему пулу дат
      let availableDates = structuredClone(this.form.allDates)
      const thisDotIndex = this.getDotIndex(this.dot)
      // const prevDot = thisDotIndex ? this.order.dots[thisDotIndex - 1] : null

      if (!thisDotIndex && !this.base.isAdmin) {
        // Для первой точки

        // offset нужен для того, чтобы понимать, что пользователь может создать заказ
        // только на завтра
        let offset = 0

        if (!this.base.isEdit && this.currentDate.time > '22:30') offset = 86400000

        availableDates = availableDates.filter(
          date => date.value >= this.currentDate.clearedDate + offset
        )
      } else if (thisDotIndex) {
        // Для остальных точек минимальным значением даты будет дата первой точки
        availableDates = availableDates.filter(date => date.value >= this.order.dots[0].date)
      }

      // Задача: https://tracker.yandex.ru/FRONTEND-1035
      // Если у предыдущей точки время >= 23:00, то минимальной датой будет только следующая дата от предыдущей точки
      // if (prevDot && prevDot.timeTo >= '23:00' && prevDot.timeTo !== '23:59') {
      //   availableDates = availableDates.filter(date => date.value > prevDot.date)
      // }

      // initial значения имеются у точек только при редактировании заказа
      // если есть изначальная дата у точки и при этом не находим эту дату в списке достпуных -
      //  добавляем в список изначальное значение
      if (this.initialDate && !availableDates.find(date => date.value === this.dot.date)) {
        const dateObject = new Date(this.initialDate)

        availableDates.unshift({
          value: this.initialDate,
          label: `${dateObject.getDate()} ${this.monthStrings[dateObject.getMonth()]}`,
        })
      }

      availableDates = availableDates.map(_date => {
        if (this.currentDate.isOtherTimezone) return _date

        const date = { ..._date }
        const isToday = this.currentDate.clearedDate === date.value
        const isTomorrow = this.currentDate.clearedDate + 86400000 === date.value

        if (isToday) date.label = 'Сегодня'
        if (isTomorrow) date.label = 'Завтра'

        return date
      })

      return availableDates
    },

    isCurrentDate() {
      return this.dot.date === this.currentDate.clearedDate
    },
  },

  methods: {
    ...mapMutations(GENERAL_STORE, ['updateDot']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),
    ...mapActions(ADDRESS_BOOK_STORE, ['setAddressBookItemTime']),

    getClosestWorkDay() {
      const { dot } = this
      let date = new Date()
      const index = this.getDotIndex(dot)
      const prevDot = index !== 0 ? this.order.dots[index - 1] : null

      if (prevDot !== null && prevDot.date > date.setHours(0, 0, 0, 0)) {
        date = new Date(prevDot.date)
      }

      if (date.getHours() >= 21) {
        date.setDate(date.getDate() + 1)
      }

      return date.setHours(0, 0, 0, 0)
    },

    timeToText(_hours, minutes) {
      const hours = _hours < 10 ? `0${_hours}` : _hours

      return `${hours}:${minutes}`
    },

    getPickupStartTime() {
      const { dot } = this
      const date = new Date()
      const hours = date.getHours()
      const minutes = date.getMinutes()

      if (dot.date < date) {
        if (minutes < 30) {
          return this.timeToText(hours, '30')
        }

        return this.timeToText(hours + 1, '00')
      }

      return '00:00'
    },
  },

  mounted() {
    if (!this.dot.date) {
      this.updateDot({
        dot: this.dot,
        data: {
          key: 'date',
          value: this.getClosestWorkDay(),
        },
      })
      this.updateDot({
        dot: this.dot,
        data: {
          key: 'timeFrom',
          value: this.form.allTimes.filter(time => time.value >= this.getPickupStartTime())[0]
            .value,
        },
      })
      this.updateDot({
        dot: this.dot,
        data: {
          key: 'timeTo',
          value: this.form.allTimes.filter(time => time.value >= '23:59')[0].value,
        },
      })
      this.calculatePrice()
    }
  },
}
